import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";
import { HttpClient } from "@angular/common/http";
import { FilterModel } from "src/models";
import { DisplayListAddModel } from "../models";
import { Observable } from "rxjs";
import { buildBulkDeleteByFilterPayload } from 'src/app/shared/services/bulk-delete-by-filter';

@Injectable({
    providedIn: 'root'
})

export class DisplayListService {
    private apiEndPoint = environment.apiBaseUrl + 'api/displayList/';

    constructor(private http: HttpClient) { }

    getPagedResult(params: any) {
        if (!params.groupId || params.groupId === -1) {
            params.groupId = null;
        }
        return this.http.get(this.apiEndPoint + 'paged-result' , {params});
    }

    getPagedList(params: any) {
        if (!params.groupId || params.groupId === -1) {
            params.groupId = null;
        }
        return this.http.get(this.apiEndPoint + 'paged-list?', {params});
    }

    getMediaAppCount(displayListId: number) {
        return this.http.get(this.apiEndPoint + `media-app-count/${displayListId}`);
    }

    add(model: DisplayListAddModel): Observable<any> {
        return this.http.post(this.apiEndPoint + 'add', model);
    }

    exists(filterModel: FilterModel, folderId?: number): Observable<any> {
        if (!filterModel.groupId || filterModel.groupId === -1) {
            filterModel.groupId = null;
        }
        if(folderId == undefined) {
            folderId = null;
        }
        return this.http.get(`${this.apiEndPoint}exists/${filterModel.groupId}/${folderId}?mineOnly=${filterModel.mineOnly}`);
    }

    folderExists(groupId?: number, mineOnly?: boolean) {
        if (groupId == undefined || groupId == -1) {
            groupId = null;
        }
        if (mineOnly == undefined) {
            mineOnly = null;
        }

        return this.http.get(`${this.apiEndPoint}has-folder/${groupId}?mineOnly=${mineOnly}`);
    }

    edit(model: any): Observable<any> {
        return this.http.post(this.apiEndPoint + 'edit', model);
    }

    getForEdit(id: number): Observable<any> {
        return this.http.get(this.apiEndPoint + 'get-for-edit/' + id);
    }

    delete(id: number) {
        return this.http.post(this.apiEndPoint + 'delete/' + id, null);
    }

    deleteBulk(ids: number[]) {
        return this.http.post(this.apiEndPoint + 'delete-bulk', ids);
    }

    deleteBulkByFilter(filterModel: any, excludedIds: number[] = []) {
        return this.http.post(this.apiEndPoint + 'delete-bulk-by-filter', buildBulkDeleteByFilterPayload(filterModel, excludedIds));
    }

    getFolderList(filterKey: string, groupId?: number, mineOnly?: boolean) {
        if (groupId == undefined) {
            groupId = null;
        }
        if (mineOnly == undefined) {
            mineOnly = null;
        }
        return this.http.get(`${this.apiEndPoint}folders/${groupId}?mineOnly=${mineOnly}&filterKey=${filterKey}`);
    }
}